module.exports = __webpack_public_path__ + "img/shoplogo.443fcb47.svg";